import { loadSubscriptionModal } from "@components/modal/subscriptionProposal"
import { JtagService } from "@services/jtag-service";

export default class NotificationAlert {

  private openModalAndTrack = (): void => {
    loadSubscriptionModal('notificationAlert');

    JtagService.trackCustomEventClick('notification_alert_box');
  }

  init = (): void => {
    const notificationBoxes = document.querySelectorAll('.js-notification-alert');

    if (notificationBoxes.length > 0) {
      JtagService.trackCustomEventImpression('notification_alert_box');
    }
    notificationBoxes.forEach((notificationBox) => notificationBox.addEventListener('click', this.openModalAndTrack));
  }
}